import {Reducer} from 'redux'
import {ResourcesActionTypes} from "@actions/resources";
import {ResourcesState} from "@models/resource";

// Type-safe initialState!
export const initialState: ResourcesState = {
    data: [],
    errors: undefined,
    loading: false,
    count: 0
};

const reducer: Reducer<ResourcesState> = (state = initialState, action) => {
    switch (action.type) {
        case ResourcesActionTypes.FETCH_REQUEST: {
            return {
                ...state,
                loading: true
            }
        }

        case ResourcesActionTypes.FETCH_SUCCESS: {
            const {data, meta} = action.payload;
            return {
                ...state,
                loading: false,
                data,
                count: meta.total_count,
                is_fetched: true
            }
        }

        case ResourcesActionTypes.FETCH_ERROR: {
            return {...state, loading: false, errors: action.payload.error}
        }

        default: {
            return state
        }
    }
};

export {reducer as resourcesReducer}
